import { UPDATE } from 'model/fspConfig';
import { useIsBusy } from 'hooks';

const useIsFspConfigUpdating = () => {
  return useIsBusy(UPDATE);
};

export default useIsFspConfigUpdating;
